import React, { useMemo, useRef } from 'react';
import { toPercent } from 'pano-utils';
import classNames from 'classnames';
import { ImageType } from '@types';
import limitNum from '@utils/limitNum';
import { useSliderContext } from './context';
import Image from '../Image';

interface Props {
  step?: number;
}

function Bar({ step = 1 }: Props) {
  const { min, max, value, scheme, onChange } = useSliderContext();
  const divRef = useRef<HTMLDivElement>(null);
  const prevRef = useRef<number>(value);
  const range = max - min;
  const posLeft = toPercent((value - min) / range);

  const ratio = useMemo(() => {
    const decimal = String(step).split('.')[1];
    if (!decimal) return 1;
    return 10 ** decimal.length;
  }, [step]);

  const getVal = (e: MouseEvent) => {
    if (!divRef.current) return value;
    const { left, right, width } = divRef.current.getBoundingClientRect();
    const clientX = limitNum({ min: left, max: right, value: e.clientX });
    const roundedVal = Math.round((((clientX - left) / width) * range) / step);
    return Math.round((roundedVal * step + min) * ratio) / ratio;
  };

  const handleMouseMove = (e: MouseEvent) => {
    const newVal = getVal(e);
    if (onChange && prevRef.current !== newVal) {
      onChange(newVal);
    }
    prevRef.current = newVal;
  };

  const handleMouseUp = () => {
    document.removeEventListener('mouseup', handleMouseUp, false);
    document.removeEventListener('mousemove', handleMouseMove, false);
  };

  const handleMouseDown = () => {
    document.addEventListener('mouseup', handleMouseUp, false);
    document.addEventListener('mousemove', handleMouseMove, false);
  };
  return (
    <div className="px-5">
      <div
        className={classNames('relative h-15 border-b-4', {
          'border-black': scheme === 'dark',
        })}
        ref={divRef}
      >
        <Image
          src={
            scheme === 'light'
              ? '/imgs/s-handler-light.65865a15d69de939597f0bd7a196d900.png'
              : '/imgs/s-handler.ab5719fea4ae64264cddc273cf8b7f3b.png'
          }
          type={ImageType.sysMedia}
          className="absolute cursor-pointer"
          alt=""
          style={{ width: 9, height: 15, left: posLeft, marginLeft: -4 }}
          onMouseDown={handleMouseDown}
        />
      </div>
    </div>
  );
}

export default Bar;
